import { IconButton, Id, isSuccess, useToasts } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IEventContactEndpoints } from "../../../shared/api/event/withEventContactEndpoints";

interface props {
	eventId: Id;
	filterId: Id | null;
	viewId: Id | undefined;
	eventContactService: IEventContactEndpoints;
}

export const EventContactExportButton: FC<props> = ({ filterId, viewId, eventContactService, eventId }) => {
	const { t } = useTranslation();
	const { showToast } = useToasts();

	const createExport = async () => {
		const response = await eventContactService.exportContacts(eventId, viewId, filterId);
		if (isSuccess(response)) {
			showToast({
				body: t("An export is being created, please wait."),
				title: t("Export"),
				type: "success",
			});
		}
	};

	return <IconButton type="button" size="small" onClick={createExport} title={t("Download")} icon="file_download" />;
};
